module.exports = __webpack_public_path__ + "static/media/vehicle-highlight.e621b46f.png";